var _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_917_5608",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 9H10.75C9.7835 9 9 9.7835 9 10.75V28.25C9 29.2165 9.7835 30 10.75 30H28.25C29.2165 30 30 29.2165 30 28.25V10.75C30 9.7835 29.2165 9 28.25 9Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.33333,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4997 14.833V24.1663M14.833 19.4997H24.1663",
    stroke: "black",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_917_5608)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7188 32.9062V25.5938H25.5938L19.5 18.2812L13.4062 25.5938H18.2812V32.9062H12.1875V32.8453C11.9827 32.8575 11.7878 32.9062 11.5781 32.9062C9.15388 32.9062 6.82893 31.9432 5.11473 30.229C3.40053 28.5148 2.4375 26.1899 2.4375 23.7656C2.4375 19.0759 5.98406 15.2539 10.5349 14.7298C10.9339 12.644 12.0472 10.7625 13.6834 9.40875C15.3196 8.05503 17.3764 7.31379 19.5 7.3125C21.6239 7.31369 23.681 8.05485 25.3176 9.40853C26.9542 10.7622 28.0681 12.6438 28.4676 14.7298C33.0184 15.2539 36.5601 19.0759 36.5601 23.7656C36.5601 26.1899 35.597 28.5148 33.8828 30.229C32.1686 31.9432 29.8437 32.9062 27.4194 32.9062C27.2147 32.9062 27.0172 32.8575 26.8101 32.8453V32.9062H20.7188Z",
    fill: "url(#paint0_linear_917_5608)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_917_5608",
    x1: 19.4988,
    y1: 7.3125,
    x2: 19.4988,
    y2: 32.9062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.263584,
    stopColor: "#605BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E5CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.bae3491652e5f18196d0260c9496f25b.svg";
export { ForwardRef as ReactComponent };